import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import EditLiveChannel from "../components/Live/EditLiveChannel";

const EditLiveChannelScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <EditLiveChannel />
      </main>
    </>
  );
};

export default EditLiveChannelScreen;
